import { HeadCell } from '../../table-old/components/expandable-row';

export const headCells: HeadCell[] = [
  {
    id: 'file-type',
    label: 'File Type',
    accessor: 'row.fileTypeName',
    disablePadding: true,
    numeric: false,
  },
  {
    id: 'g-file-Type-number',
    label: 'GFile Type #',
    accessor: 'row.fileTypeId',
    disablePadding: true,
    numeric: false,
  },
  {
    id: 'file-name',
    label: 'File Name',
    accessor: 'row.fileName',
    disablePadding: true,
    numeric: false,
  },
  {
    id: 'sha-1',
    label: 'SHA 1',
    accessor: 'row.hash',
    disablePadding: true,
    numeric: false,
  },
  {
    id: 'uploaded',
    label: 'Uploaded',
    accessor: 'row.upload',
    disablePadding: true,
    numeric: false,
  },
  {
    id: 'status',
    label: 'File Status',
    accessor: 'row.commands[0].status',
    disablePadding: true,
    numeric: false
  },
];
